import React from 'react';
import PropTypes from 'prop-types';

import ImageDropzone from '../image_dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-regular-svg-icons';

class PhotoUploader extends React.Component {
  static propTypes = {
    allowUpload: PropTypes.func,
    forwardedRef: PropTypes.any,
    uploadCopy: PropTypes.string,
    validFileFormats: PropTypes.string,
    onUpload: PropTypes.func.isRequired,
  }

  dropBox = (
    <div className="p-4 h-100" style={{ cursor: 'pointer' }}>
      <h6 className="text-center dz-message">
        <FontAwesomeIcon className="text-muted pe-1" icon={faImage} />
        <span className="text-muted">
          {this.props.uploadCopy || 'Drag files, or click here to add files' }
        </span>
      </h6>
    </div>
  )

  render() {
    return (
      <div className="h-100">
        <ImageDropzone
          accept={this.props.validFileFormats}
          allowUpload={this.props.allowUpload}
          className="h-100"
          disablePreview
          dropBox={this.dropBox}
          dropZoneClassName="media-uploader h-100"
          forwardedRef={this.props.forwardedRef}
          onUploadComplete={this.props.onUpload}
        />
      </div>
    );
  }
}

export default PhotoUploader;
